interface IconProps {
  color: string;
  size?: string;
}

export default function PictureIcon({ color, size }: IconProps) {
  return (
    <svg viewBox="317.51 431.45 174.94 158.01" width={size} height={size}>
      <path
        fill={color}
        d="M461.406 431.45H348.54c-17.098 0-31.035 13.937-31.035 31.034v95.938c0 17.101 13.937 31.039 31.035 31.039h112.867c17.102 0 31.04-13.938 31.04-31.04v-95.937c0-17.097-13.938-31.035-31.04-31.035m14.11 69.523-24.153-24.153c-3.218-3.218-8.41-3.328-11.738-.226l-41.648 38.715-21.106-21.106c-3.219-3.219-8.41-3.332-11.738-.226l-30.7 28.5v-59.993c0-7.785 6.32-14.105 14.106-14.105h112.867c7.79 0 14.11 6.32 14.11 14.105Zm0 0"
      ></path>
    </svg>
  );
}
